import { redirectToSearchUrl } from 'app/search/components/autoSuggest/autoSuggestUtils';
import React from 'react';
import { injectIntl, FormattedMessage, useIntl } from 'react-intl';

const SearchInput = () => {
  const intl = useIntl();
  const inputRef = React.useRef(null);

  const onSubmit = e => {
    e.preventDefault();
    window.location.href = redirectToSearchUrl(inputRef.current.value);
  };

  return (
    <div className="search__container">
      <h2>
        <FormattedMessage id="search.results.no.matches" description="No matches" />
      </h2>
      <h3>
        <FormattedMessage id="search.results.no.matches.hint" description="Hint" />
      </h3>
      <form onSubmit={onSubmit} className="search__wrapper" style={{ paddingTop: 10 }}>
        <input
          ref={inputRef}
          aria-label="Search"
          placeholder={intl.formatMessage({ id: 'ui.search.input.placeHolder' })}
          maxLength={256}
          type="text"
          className="search__input"
        />
        <button type="submit" className="nav__btn nav__btn--search">
          <i className="nav__btn-icon icon-search" />
        </button>
      </form>
    </div>
  );
};

export default injectIntl(SearchInput);
